import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidFolderClosed2",
  "use": "SolidFolderClosed2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"SolidFolderClosed2\"><defs><path d=\"M9.217 5a2 2 0 011.506.683L11.875 7H18a2 2 0 012 2H7.838a2 2 0 00-1.952 1.564L4 19V7a2 2 0 012-2h3.217zm10.913 5a1.5 1.5 0 011.464 1.825l-1.333 6A1.5 1.5 0 0118.797 19H5l1.739-7.825A1.5 1.5 0 018.203 10H20.13z\" id=\"SolidFolderClosed2_a\" /></defs><use xlink:href=\"#SolidFolderClosed2_a\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol